module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/joiningdetails/joiningdetails-grid/joiningdetails-grid.component.css
// module id = ./src/app/hrms/serviceregister/joiningdetails/joiningdetails-grid/joiningdetails-grid.component.css
// module chunks = main